export kreditKeyBase = 'kredit.'
export transactionHistoryKey = kreditKeyBase + 'transaction_history'

export transactionHistorySetting = (settings) ->
  setting = settings.safeFindBy(key: transactionHistoryKey)?.value or {}

  { enabled: setting.enabled ? true }
